import { cn } from "ui";
import { ReportsNavigationTabs } from "../../../components/NavigationTabs/ReportsNavigationTabs";
import { ReportsFilters } from "./ReportsFilters";
import { useStickyBorder } from "./useStickyBorder";

type ReportsStickyHeaderProps = {
  activeTab: React.ComponentProps<typeof ReportsNavigationTabs>["activeTab"];
};

export function ReportsStickyHeader({ activeTab }: ReportsStickyHeaderProps) {
  const { sentinelRef, isStuck } = useStickyBorder();

  return (
    <>
      <div ref={sentinelRef} className="-mb-4" />

      <div
        className={cn(
          "sticky top-0 z-10 border-b border-transparent bg-foundations-default",
          isStuck && "border-foundations-subtle"
        )}
      >
        <ReportsNavigationTabs activeTab={activeTab} />

        <div className="flex flex-col justify-center py-4">
          <ReportsFilters />
        </div>
      </div>
    </>
  );
}
